import React from "react";

/** Solid orange fill when there is no estimate (bar at 100%). */
const noEstimateBarStyle = { backgroundColor: "rgb(251 146 60)" }; // orange-400

/**
 * Visual progress bar showing reported hours vs estimated hours.
 * Gray bar = total estimated hours, blue fill = reported hours.
 * When there is no estimate: same bar layout, 100% fill with solid orange, text "Xh / 0h".
 */
const HoursProgressBar = ({ estimatedHours = 0, reportedHours = 0 }) => {
  const hasEstimate = estimatedHours != null && estimatedHours > 0;
  const reported = reportedHours ?? 0;

  // No estimate: full bar (100%) with solid orange, label "Xh / 0h"
  if (!hasEstimate) {
    return (
      <div className="flex items-center gap-3">
        <div className="flex-1 min-w-0">
          <div className="w-full bg-gray-200 rounded-xl h-2 shadow-sm overflow-hidden">
            <div
              className="h-2 rounded-xl transition-all duration-300"
              style={{ width: "100%", ...noEstimateBarStyle }}
            />
          </div>
        </div>
        <div className="flex-shrink-0">
          <span className="text-sm font-medium text-gray-700">
            {reported}h / 0h
          </span>
        </div>
      </div>
    );
  }

  // Calculate percentage, cap at 100%
  const percentage = Math.min((reported / estimatedHours) * 100, 100);

  return (
    <div className="flex items-center gap-3">
      <div className="flex-1 min-w-0">
        <div className="w-full bg-gray-200 rounded-xl h-2 shadow-sm overflow-hidden">
          <div
            className="bg-blue-600 h-2 rounded-xl transition-all duration-300"
            style={{ width: `${percentage}%` }}
          />
        </div>
      </div>
      <div className="flex-shrink-0">
        <span className="text-sm font-medium text-gray-700">
          {reported}h / {estimatedHours}h
        </span>
      </div>
    </div>
  );
};

export default HoursProgressBar;
